import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { UserApiKeyService } from "Bands/services/UserApiKeyService";
import { isArray } from "lodash-es";
import { useMemo } from "react";

const queryKey = ["userApiKey"];

export const useApiKey = () => {
  const queryClient = useQueryClient();

  const createKey = useMutation({
    mutationFn: UserApiKeyService.createUserApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const getKeys = useQuery({
    queryKey,
    queryFn: () => UserApiKeyService.getUserApiKey(),
  });

  const deleteKey = useMutation({
    mutationFn: UserApiKeyService.deleteUserApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const hasApiKey = useMemo(() => isArray(getKeys.data) && getKeys.data.length > 0, [getKeys.data]);

  return {
    createKey,
    getKeys,
    deleteKey,
    hasApiKey,
  };
};
